/* eslint-disable @typescript-eslint/no-empty-function */
import { Agent } from 'data/firestore/agent/types';
import { EntityGet } from 'data/firestore/types';
import React from 'react';

export type EnabledAppAvailability = 'preview' | 'available' | 'deprecated' | 'retired';

export type EnabledAppCapability =
    | 'ui'
    | 'persistence'
    | 'search'
    | 'storage'
    | 'documentation'
    | 'apiKey'
    | 'serviceAccount';

export interface EnabledApp {
    appKey: string;
    slug: string;
    version: string;
    displayName: string;
    description: string;
    owner: string;
    availability: EnabledAppAvailability;
    capabilities: EnabledAppCapability[];
}

export interface OrganizationEnabledAppsEnvelope {
    data: {
        apps: EnabledApp[];
    };
}

export interface Context {
    agent?: EntityGet<Agent> | null;
    isLoading?: boolean;
    enabledApps: EnabledApp[];
    isLoadingEnabledApps?: boolean;
    isAppEnabled: (appKey: string) => boolean;
}

const context = React.createContext<Context>({
    isLoading: false,
    enabledApps: [],
    isLoadingEnabledApps: false,
    isAppEnabled: () => false,
});

export const { Provider, Consumer } = context;

export default context;
